import passageInstruction from '../sounds/spanish/clpl_passage_instructions.mp3';
import directionInstruction from '../sounds/spanish/clpl_direction.mp3';
import clickOk from '../sounds/spanish/clpl_click_ok.mp3';
import scrollIntroInstruction from '../sounds/spanish/clpl_scroll_intro.mp3';
import scrollDownInstruction from '../sounds/spanish/clpl_scroll_down.mp3';
import scrollReadyInstruction from '../sounds/spanish/clpl_ready.mp3';
import scrollInstruction from '../sounds/spanish/clpl_ready_instructions.mp3';
import scrollReadyClickOk from '../sounds/spanish/clpl_ready_click_ok.mp3';
import modelCorrectResponse from '../sounds/spanish/clpl_model_correct_answer_selected.mp3';
import modelIncorrectResponse from '../sounds/spanish/clpl_model_incorrect_answer_selected.mp3';
import modelSecondIncorrectResponse from '../sounds/spanish/clpl_model_incorrect_answer_selected_twice.mp3';
import modelInstructionStart from '../sounds/spanish/clpl_model_sentence_start.mp3';
import modelInstructionEnd from '../sounds/spanish/clpl_model_sentence_end.mp3';
import modelOptionOne from '../sounds/spanish/clpl_model_option_one.mp3';
import modelOptionTwo from '../sounds/spanish/clpl_model_option_two.mp3';
import modelOptionThree from '../sounds/spanish/clpl_model_option_three.mp3';
import practiceIntro from '../sounds/spanish/clpl_practice_intro.mp3';
import practiceEnd from '../sounds/spanish/clpl_practice_sentence_end.mp3';
import practiceOptionOne from '../sounds/spanish/clpl_practice_option_one.mp3';
import practiceOptionTwo from '../sounds/spanish/clpl_practice_option_two.mp3';
import practiceOptionThree from '../sounds/spanish/clpl_practice_option_three.mp3';
import practiceCorrectAnswerSelected from '../sounds/spanish/clpl_practice_correct_answer_selected.mp3';
import practiceIncorrectAnswerSelected from '../sounds/spanish/clpl_practice_incorrect_answer_selected.mp3';
import practiceIncorrectAnswerSelectedTwice from '../sounds/spanish/clpl_practice_incorrect_answer_selected_twice.mp3';
import { MODEL, PRACTICE, SCROLL } from '../constants/assessmentItemType';

const CLPL_INSTRUCTIONS = {
    passageInstruction,
    [MODEL]: {
        directionInstruction,
        modelCorrectResponse,
        modelIncorrectResponse,
        modelSecondIncorrectResponse,
        modelInstructionStart,
        modelInstructionEnd,
        modelOptionOne,
        modelOptionTwo,
        modelOptionThree,
        clickOk,
    },
    [PRACTICE]: {
        practiceIntro,
        practiceEnd,
        practiceOptionOne,
        practiceOptionTwo,
        practiceOptionThree,
        practiceCorrectAnswerSelected,
        practiceIncorrectAnswerSelected,
        practiceIncorrectAnswerSelectedTwice,
        clickOk,
    },
    [SCROLL]: {
        scrollIntroInstruction,
        scrollDownInstruction,
        scrollReadyInstruction,
        scrollInstruction,
        scrollReadyClickOk,
        clickOk,
    },
};

export default CLPL_INSTRUCTIONS;
